import gql from 'graphql-tag';
import collegeEventFilterFragment from './collegeEventFilterFragment';
import collegeEventLocationFragment from '../../CollegeEventLocation/graphql/collegeEventLocationFragment';

const query = gql`
  query fetchCollegeEvent($id: ID!) {
    viewer {
      id,
      eventLocations {
        ...CollegeEventLocation
      }
      eventFilters {
        ...CollegeEventFilter
      }
    }
    node(id: $id) {
      ...on CollegeEvent {
            id
            version
            name
            timezone
            startTime
            endTime
            eventDateTime
            eventEndDateTime
            institution
            eventDescription
            registrationUrl
            registrationDeadline
            registrationDeadlineTime
            displayIn {
              naviancestudent
              camino
            }
            status
            created
            virtual
            lastModifiedDate
            lastModifiedBy
            collegeEventFilter {
                ...CollegeEventFilter
            }
            collegeEventLocation {
                ...CollegeEventLocation
            }
        }
    }
  }
  ${collegeEventFilterFragment}
  ${collegeEventLocationFragment}
`;

export default query;
